module.exports = __webpack_public_path__ + "static/media/eva_people-group.63a8c2e1.svg";